(function () {
  if (window.jdEntrega) return;

  var DIA = 86400000;
  var cacheFestivos = {};

  function utc(y, m, d) {
    return Date.UTC(y, m, d);
  }

  function enesimoDia(y, m, diaSemana, n) {
    var primero = new Date(utc(y, m, 1)).getUTCDay();
    var salto = (diaSemana - primero + 7) % 7;
    return utc(y, m, 1 + salto + 7 * (n - 1));
  }

  function ultimoDia(y, m, diaSemana) {
    var ultimo = new Date(utc(y, m + 1, 0));
    var salto = (ultimo.getUTCDay() - diaSemana + 7) % 7;
    return utc(y, m, ultimo.getUTCDate() - salto);
  }

  function observado(y, m, d) {
    var t = utc(y, m, d);
    var dia = new Date(t).getUTCDay();
    if (dia === 6) return t - DIA;
    if (dia === 0) return t + DIA;
    return t;
  }

  function festivosDelAno(y) {
    return [
      observado(y, 0, 1),
      enesimoDia(y, 0, 1, 3),
      enesimoDia(y, 1, 1, 3),
      ultimoDia(y, 4, 1),
      observado(y, 5, 19),
      observado(y, 6, 4),
      enesimoDia(y, 8, 1, 1),
      enesimoDia(y, 9, 1, 2),
      observado(y, 10, 11),
      enesimoDia(y, 10, 4, 4),
      observado(y, 11, 25)
    ];
  }

  function esFestivo(t) {
    var y = new Date(t).getUTCFullYear();
    if (!cacheFestivos[y]) {
      var lista = festivosDelAno(y).concat(festivosDelAno(y + 1));
      cacheFestivos[y] = {};
      lista.forEach(function (f) {
        cacheFestivos[y][f] = true;
      });
    }
    return cacheFestivos[y][t] === true;
  }

  function leerFecha(texto) {
    var m = /^(\d{4})-(\d{1,2})-(\d{1,2})$/.exec(String(texto || '').trim());
    if (!m) return null;
    var mes = +m[2];
    var dia = +m[3];
    if (mes < 1 || mes > 12 || dia < 1 || dia > 31) return null;
    return utc(+m[1], mes - 1, dia);
  }

  function hoyEn(zona) {
    try {
      var partes = new Intl.DateTimeFormat('en-US', {
        timeZone: zona || 'America/New_York',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      }).formatToParts(new Date());
      var valor = function (tipo) {
        return +partes.find(function (p) {
          return p.type === tipo;
        }).value;
      };
      return utc(valor('year'), valor('month') - 1, valor('day'));
    } catch (e) {
      var ahora = new Date();
      return utc(ahora.getFullYear(), ahora.getMonth(), ahora.getDate());
    }
  }

  function crearLaborable(cerrados) {
    var extra = {};
    String(cerrados || '')
      .split(/[\s,;]+/)
      .map(leerFecha)
      .filter(Boolean)
      .forEach(function (t) {
        extra[t] = true;
      });
    return function (t) {
      var dia = new Date(t).getUTCDay();
      return dia !== 0 && dia !== 6 && !esFestivo(t) && !extra[t];
    };
  }

  function sumarLaborables(desde, n, laborable) {
    var t = desde;
    var cuenta = 0;
    while (cuenta < n) {
      t += DIA;
      if (laborable(t)) cuenta += 1;
    }
    return t;
  }

  function plazo(cfg) {
    var hoy = hoyEn(cfg.zona);
    var fin = leerFecha(cfg.tempHasta);
    var temporal = fin !== null && hoy <= fin && +cfg.tempMax > 0;
    return {
      hoy: hoy,
      min: temporal ? +cfg.tempMin : +cfg.min,
      max: temporal ? +cfg.tempMax : +cfg.max,
      temporal: temporal
    };
  }

  var formatos = {
    corto: { month: 'short', day: 'numeric' },
    dia: { weekday: 'short', month: 'short', day: 'numeric' },
    largo: { weekday: 'long', month: 'long', day: 'numeric' }
  };

  function ordinal(n) {
    var r = n % 100;
    if (r >= 11 && r <= 13) return n + 'th';
    return n + (['th', 'st', 'nd', 'rd'][n % 10] || 'th');
  }

  function formatear(t, formato, idioma) {
    if (formato === 'ordinal') {
      try {
        var semana = new Intl.DateTimeFormat(idioma || 'en-US', { timeZone: 'UTC', weekday: 'long' }).format(new Date(t));
        var mes = new Intl.DateTimeFormat(idioma || 'en-US', { timeZone: 'UTC', month: 'long' }).format(new Date(t));
        return semana + ', ' + mes + ' ' + ordinal(new Date(t).getUTCDate());
      } catch (e) {
        return new Date(t).toISOString().slice(0, 10);
      }
    }
    var opciones = Object.assign({ timeZone: 'UTC' }, formatos[formato] || formatos.corto);
    try {
      return new Intl.DateTimeFormat(idioma || 'en-US', opciones).format(new Date(t));
    } catch (e) {
      return new Date(t).toISOString().slice(0, 10);
    }
  }

  function escapar(texto) {
    var div = document.createElement('div');
    div.textContent = texto;
    return div.innerHTML;
  }

  function configDe(el) {
    return {
      min: el.dataset.min,
      max: el.dataset.max,
      tempMin: el.dataset.tempMin,
      tempMax: el.dataset.tempMax,
      tempHasta: el.dataset.tempHasta,
      zona: el.dataset.zona,
      cerrados: el.dataset.cerrados,
      formato: el.dataset.formato,
      cuenta: el.dataset.cuenta,
      idioma: el.dataset.idioma
    };
  }

  function pintar(el) {
    var cfg = configDe(el);
    var p = plazo(cfg);
    var laborable = cfg.cuenta === 'naturales' ? function () { return true; } : crearLaborable(cfg.cerrados);
    var desde = sumarLaborables(p.hoy, p.min, laborable);
    var hasta = sumarLaborables(p.hoy, p.max, laborable);
    var valores = {
      desde: '<span class="jd-entrega__fecha">' + escapar(formatear(desde, cfg.formato, cfg.idioma)) + '</span>',
      hasta: '<span class="jd-entrega__fecha">' + escapar(formatear(hasta, cfg.formato, cfg.idioma)) + '</span>',
      min: String(p.min),
      max: String(p.max),
      plazo: p.min + '-' + p.max
    };
    el.querySelectorAll('[data-jd-entrega-texto]').forEach(function (destino) {
      var plantilla = destino.dataset.plantilla || '';
      destino.innerHTML = plantilla.replace(/\[(desde|hasta|min|max|plazo)\]/g, function (_, clave) {
        return valores[clave];
      });
      destino.hidden = false;
    });
  }

  function iniciar(raiz) {
    (raiz || document).querySelectorAll('[data-jd-entrega]').forEach(pintar);
  }

  window.jdEntrega = { iniciar: iniciar, plazo: plazo, sumarLaborables: sumarLaborables, crearLaborable: crearLaborable };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      iniciar();
    });
  } else {
    iniciar();
  }
  document.addEventListener('shopify:section:load', function (e) {
    iniciar(e.target);
  });
})();
